import { jsx } from 'react/jsx-runtime';
import { theme } from '../../constants/theme.mjs';
import { Reveal as Reveal$1 } from './Reveal.styles.mjs';
"use strict";
const Reveal = ({
  children,
  index,
  // multiplies `index` by this value to determine how long to delay the animation between items of a list
  animationAdjustment = 0.125,
  className,
  playAnimation = true,
  playSpeed = 0.3,
  backgroundColor = theme.colors.white
}) => {
  return /* @__PURE__ */jsx(Reveal$1, {
    $playAnimation: playAnimation,
    $animationDelay: index * animationAdjustment,
    $playSpeed: playSpeed,
    $backgroundColor: backgroundColor,
    className,
    children
  });
};
export { Reveal };
//# sourceMappingURL=Reveal.mjs.map
